import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    ColumnDirective, ColumnsDirective,
    GridComponent, Grid, Inject, Page, Sort, Filter, Resize,
    Toolbar, ExcelExport, PdfExport, ColumnChooser
} from '@syncfusion/ej2-react-grids';
import { AggregatesDirective, Aggregate, AggregateColumnsDirective, AggregateDirective, AggregateColumnDirective } from '@syncfusion/ej2-react-grids';

import HttpClient from './../../../services/httpClient';
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import { Dropdown, Select } from 'semantic-ui-react'
import { Button } from 'semantic-ui-react'
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';
import { useTranslation } from "react-i18next";
import { finishLoading, setTitle, startLoading } from "./../../../store/actions/uiAction";
import { logReportService } from "./../../../services/logReportService";
import ComboHotelSala from "./../../../components/combo-hotel-sala/combo-hotel-sala";
import { MultiSelectComponent, CheckBoxSelection, Inject as InjectDrop } from '@syncfusion/ej2-react-dropdowns';

const SalesReport = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [dateStart, setDateStart] = useState(new Date());
    const [dateEnd, setDateEnd] = useState(new Date());
    const [rowData, setRowData] = useState([]);
    const [NameSala, setNameSala] = useState([]);
    const [NameHotel, setNameHotel] = useState([]);
    const [NameEstatusContract, setNameEstatusContract] = useState([]);
    const [NameTipoVta, setNameTipoVta] = useState([]);
    const [NamePrograma, setNamePrograma] = useState([]);

    const user = useSelector(state => state.auth.currentUser);
    const { idSaleRoom, idHotel } = useSelector(state => state.user.param);
    const [estatusContratosData, setEstatusContratosData] = useState([]);
    const [tiposVtaData, setTiposVtaData] = useState([]);
    const [programasData, setProgramasData] = useState([]);
    const toolbarOptions = ['ColumnChooser'];

    let grid = null;

    let mulObjEstatus = [];
    let mulObjtiposVta = [];
    let mulObjProgramas = null;

    const options = [
        { key: 'excel', icon: 'edit', text: 'Export to excel', value: 'excel' },
        { key: 'pdf', icon: 'delete', text: 'Export to pdf', value: 'pdf' },
    ]

    const checkFields = { text: 'Name', value: 'Code' };

    const onChangeDateStart = (event, data) => setDateStart(data.value);
    const onChangeDateEnd = (event, data) => setDateEnd(data.value);

    const getDataReport = (url) => {
        dispatch(startLoading());
        return new Promise((resolve, eject) => {
            HttpClient.get(url)
                .then(response => {
                    dispatch(finishLoading());
                    resolve(response);
                })
                .catch(error => {
                    dispatch(finishLoading());
                    eject(error);
                })
        });
    }

    const handleViewButton = () => {
        getSalesReport();
    }

    const getData = (url, data) => {
        dispatch(startLoading());
        return new Promise((resolve, eject) => {
            HttpClient.get(url, data)
                .then(response => {
                    dispatch(finishLoading());
                    resolve(response);
                })
                .catch(error => {
                    dispatch(finishLoading());
                    eject(error);
                })
        });
    }

    const getOptionData = (url) => {
        return new Promise((resolve, eject) => {
            getData(url).then((response) => {
                if (response.status === 200) {
                    let obj = response.data;
                    let res = [];
                    for (let i in obj) {
                        let item = { Code: obj[i].id, Name: obj[i].name };
                        res.push(item)
                    }

                    resolve(res);
                }
            })
        })

    }

    const getEstatusContratosData = () => {
        getOptionData('/catalog/estatuscontratos/0')
            .then((response) => {
                setEstatusContratosData(response);
            })
    }

    const getTiposVtaData = () => {
        getOptionData('/catalog/tiposvta')
            .then((response) => {
                setTiposVtaData(response);
            })
    }

    const getProgramasData = () => {
        getOptionData('/catalog/programas')
            .then((response) => {
                setProgramasData(response);
            })
    }

    const getSalesReport = () => {

        const date1 = dateStart.toISOString().slice(0, 10).replace(/-/g, '');
        const date2 = dateEnd.toISOString().slice(0, 10).replace(/-/g, '');
        const estatatusleads = (mulObjEstatus != null && mulObjEstatus.value.length > 0) ? mulObjEstatus.value.map(String).toString() : "0";
        const tiposvta = (mulObjtiposVta != null && mulObjtiposVta.value.length > 0) ? mulObjtiposVta.value.map(String).toString() : "0";
        const programas = (mulObjProgramas?.value?.length > 0) ? mulObjProgramas.value.map(String).toString() : "0";

        getDataReport(`/catalog/getNameSalavtaId/${idSaleRoom}`).then((response) => {
            if (response.status === 200) {
                setNameSala(response.data);
            }
        })

        getDataReport(`/catalog/getNameHotelId/${idHotel}`).then((response) => {
            if (response.status === 200) {
                setNameHotel(response.data);
            }
        })

        getDataReport(`/catalog/getNameEstatusContratoId/${estatatusleads}`).then((response) => {
            if (response.status === 200) {
                setNameEstatusContract(response.data);
            }
        })

        getDataReport(`/catalog/getNameTipoVentaId/${tiposvta}`).then((response) => {
            if (response.status === 200) {
                setNameTipoVta(response.data);
            }
        })

        getDataReport(`/catalog/getNameProgramaId/${programas}`).then((response) => {
            if (response.status === 200) {
                console.log(response.data);
                
                setNamePrograma(response.data);
            }
        })

       

        getDataReport(`/reports/sales-report/${date1}/${date2}/${idSaleRoom}/${idHotel}/${estatatusleads}/${tiposvta}/${programas}`).then((response) => {
            if (response.status === 200) {
                setRowData(response.data);
                logReportService.add('Sales Report', user);
            }
        })
    }

    // Reporte
    const handleButtonOption = (opt) => {
        if (grid && opt.target.innerText === 'Export to excel') {
            export2Excel();
        } else {
            if (grid && opt.target.innerText === 'Export to pdf') {
                grid.pdfExport();
            }
        }
    }

    const export2Excel = () => {
        const date1 = dateStart.toDateString();
        const date2 = dateEnd.toDateString();
        const excelExportProperties = {
            fileName: t('menusidebar.label.sales-report') + ".xlsx",
            theme: {
                caption: { fontName: 'Calibri', fontColor: '#666666', fontSize: 13 },
                header: { fontName: 'Calibri', fontColor: '#000000', backColor: '#3F97BF', fontSize: 13 },
            },
            header: {
                headerRows: 8,
                rows: [
                    { cells: [{ colSpan: 4, value: "LVC KCS " + t('menusidebar.label.sales-report'), style: { fontColor: '#000000', fontSize: 20, hAlign: 'Left', bold: true, } }] },
                    { cells: [{ colSpan: 4, value: "SALES ROOM: " + NameSala["name"], style: { fontColor: '#000000', fontSize: 13, hAlign: 'Left', bold: true, } }] },
                    { cells: [{ colSpan: 4, value: "HOTELS: " + NameHotel["name"], style: { fontColor: '#000000', fontSize: 13, hAlign: 'Left', bold: true, } }] },
                    { cells: [{ colSpan: 4, value: "SALES TYPE: " + NameTipoVta[0]["name"], style: { fontColor: '#000000', fontSize: 13, hAlign: 'Left', bold: true, } }] },
                    { cells: [{ colSpan: 4, value: "STATUS CONTRACT: " + NameEstatusContract[0]["name"], style: { fontColor: '#000000', fontSize: 13, hAlign: 'Left', bold: true, } }] },
                    { cells: [{ colSpan: 4, value: "PROGRAMS: " + NamePrograma[0]["name"], style: { fontColor: '#000000', fontSize: 13, hAlign: 'Left', bold: true, } }] },
                    { cells: [{ colSpan: 4, value: date1 + " - " + date2, style: { fontColor: '#000000', fontSize: 13, hAlign: 'Left', bold: true, } }] },
                ]
            }
        }
        grid.excelExport(excelExportProperties);
    }

    const handleExport2Excel = () => {
        if (grid) {
            export2Excel();
        }
    }

    const handleToolbarClick = (args) => {
        if (grid && args.item.id === 'grid_excelexport') {
            export2Excel();
        } else {
            if (grid && args.item.id === 'grid_pdfexport') {
                grid.pdfExport();
            }
        }
    }

    const dataBound = () => {
        if (grid) {
            grid.autoFitColumns();
        }
    }

    function footerSum(props) {
        return (<span>{props.Sum}</span>);

    }

    function customAggregateFnSumTieneFlujo() {
        var gridData = grid.dataSource; // gridObject.dataSource returns entire data if the grid having local dataSource
        var totalSum1 = 0;
        // do your calculation as you want with the entire dataset
        for (var i = 0; i < gridData.length; i++) {

            gridData[i]['tieneflujo'] == 'SI' ? totalSum1 = totalSum1 + 1 : totalSum1 = totalSum1;

        }

        return totalSum1;

    }

    // Fin Reporte
    useEffect(() => {
        getEstatusContratosData();
        getTiposVtaData();
        getProgramasData();
        dispatch(setTitle(t('menusidebar.label.sales-report')));
    }, []);


    return (
        <div className="container-fluid">
            <ComboHotelSala />

            <div className="row col-md-12">
                <div className="col-md-3 form-group">
                    <label >Date start:</label>
                    <SemanticDatepicker className="col-md-12" name="dateStart" value={dateStart} onChange={onChangeDateStart} />

                </div>
                <div className="col-md-3 form-group ">

                    <label >Date end:</label>
                    <SemanticDatepicker className="col-md-12" name="dateEnd" value={dateEnd} onChange={onChangeDateEnd} />

                </div>
                <div className="col-md-6 form-group">
                    <label>Programas:</label>
                    <MultiSelectComponent
                        id="programas"
                        ref={(scope) => { mulObjProgramas = scope; }}
                        dataSource={programasData}
                        fields={checkFields}
                        placeholder="Seleccionar programas"
                        mode="CheckBox"
                        showSelectAll={true}
                        value={[]}
                        showDropDownIcon={true}
                        filterBarPlaceholder="Buscar programa"
                        popupHeight="350px"
                    >
                        <InjectDrop services={[CheckBoxSelection]} />
                    </MultiSelectComponent>
                </div>
                <div className="col-md-6 form-group">
                    <label>Sales types:</label>
                    <MultiSelectComponent id="checkbox" ref={(scope) => { mulObjtiposVta = scope; }} dataSource={tiposVtaData}
                        fields={checkFields} placeholder="Select type" mode="CheckBox" showSelectAll={true}
                        showDropDownIcon={true} filterBarPlaceholder="Search estatus" popupHeight="350px" value={[]}              >
                        <Inject services={[CheckBoxSelection]} />
                    </MultiSelectComponent>
                </div>
                <div className="col-md-6 form-group">
                    <label>Status contract:</label>
                    <MultiSelectComponent id="checkbox" ref={(scope) => { mulObjEstatus = scope; }} dataSource={estatusContratosData}
                        fields={checkFields} placeholder="Select estatus" mode="CheckBox" showSelectAll={true} value={[]}
                        showDropDownIcon={true} filterBarPlaceholder="Search estatus" popupHeight="350px"                    >
                        <Inject services={[CheckBoxSelection]} />
                    </MultiSelectComponent>
                </div>
                <div className="col-md-6 form-group">
                    <Button primary onClick={handleViewButton}>View Report</Button>
                    <Button positive onClick={handleExport2Excel}>Export Report</Button>
                    {/*<Button.Group className="col-md-3" color='orange'>
                        <Button onClick={handleExport2Excel}>Print Report</Button>
                        <Dropdown
                            className='button icon'
                            floating
                            options={options}
                            onChange={handleButtonOption}
                            trigger={<></>}
                        />
                        </Button.Group>*/}

                </div>
            </div>
            <div>
                <GridComponent id="grid" height='100%' width='auto'
                    dataSource={rowData}
                    allowSorting={true}
                    allowResizing={true}
                    allowExcelExport={true}
                    allowPdfExport={false}

                    toolbar={toolbarOptions}
                    showColumnChooser={true}
                    toolbarClick={handleToolbarClick}
                    dataBound={dataBound}
                    ref={g => grid = g}
                >
                    <Inject services={[Sort, Toolbar, ExcelExport, Resize, Aggregate, ColumnChooser]} />
                    <ColumnsDirective>
                        <ColumnDirective field='rownum' headerText="Num" min='5' textAlign="Left" />
                        <ColumnDirective field='tieneflujo' headerText="Tiene flujo" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='lead' headerText="Lead" minWidth='20' textAlign="Left" />
                        <ColumnDirective field='fechaVta' headerText="Sale date" Width='10' textAlign="center" />
                        <ColumnDirective field='fechaProceso' headerText="Proc date" minWidth='10' textAlign="center" />
                        <ColumnDirective field='fechaCxL' headerText="Cxl date " minWidth='10' textAlign="center" />
                        <ColumnDirective field='location' headerText="Location" minWidth='20' textAlign="Left" />
                        <ColumnDirective field='cont' headerText="N# sale" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='empresa' headerText="Enterprise" minWidth='50' textAlign="Left" />
                        <ColumnDirective field='agencia' headerText="Agency" minWidth='50' textAlign="Left" />
                        <ColumnDirective field='membresia' headerText="Membership" minWidth='50' textAlign="Left" />
                        <ColumnDirective field='tipoMemb' headerText="Member type" Width='10' textAlign="Left" />
                        <ColumnDirective field='tipoVta' headerText="Sale type" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='statusCto' headerText="Status Cto" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='nombre' headerText="Member" minWidth='20' textAlign="Left" />
                        <ColumnDirective field='calif' headerText="Calif" minWidth='20' textAlign="Left" />
                        <ColumnDirective field='califsale' headerText="Calif Sale" minWidth='20' textAlign="Left" />
                        <ColumnDirective field='country' headerText="Country" minWidth='20' textAlign="Left" />
                        <ColumnDirective field='processable' headerText="Proc Vol" minWidth='20' textAlign="Right" />
                        <ColumnDirective field='oopVolume' headerText="OOP Vol" minWidth='50' textAlign="Right" />
                        <ColumnDirective field='downgrade' headerText="Downgrade Vol" minWidth='50' textAlign="Right" />
                        <ColumnDirective field='cancelledVolume' headerText="Cancel Vol" minWidth='20' textAlign="Right" />
                        <ColumnDirective field='totalVolume' headerText="Total Proc" minWidth='20' textAlign="Right" />
                        <ColumnDirective field='volumensiniva' headerText="Volumen Sin Iva" minWidth='20' textAlign="Right" />
                        <ColumnDirective field='pendingVolume' headerText="Pend Vol" minWidth='20' textAlign="Right" />
                        <ColumnDirective field='ccobrado' headerText="Closing C" minWidth='20' textAlign="Right" />
                        <ColumnDirective field='engancheTDC' headerText="DP Debit/Credit" minWidth='20' textAlign="Right" />
                        <ColumnDirective field='engancheVCM' headerText="DP VCM" minWidth='20' textAlign="Right" />
                        <ColumnDirective field='dpCollected' headerText="DP Total" minWidth='20' textAlign="Right" />
                        <ColumnDirective field='dpCollectedPorcent' headerText="DP%" minWidth='20' textAlign="Right" format="P2" />
                        <ColumnDirective field='enganchePendiente' headerText="DP pending" minWidth='20' textAlign="Right" />
                        <ColumnDirective field='moneda' headerText="Currency" minWidth='50' textAlign="Left" />
                           <ColumnDirective field='years' headerText="Years" minWidth='50' textAlign="Left" />
                        <ColumnDirective field='pr1noemploye' headerText="# Emp" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='pr1' headerText="Concierge 1" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='pr2noemploye' headerText="# Emp" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='pr2' headerText="Concierge 2" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='linernoemploye' headerText="# Emp" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='liner' headerText="Liner" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='ftmnoemp' headerText="# Emp" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='ftm' headerText="FTM" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='ftbnoemp' headerText="# Emp" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='ftb' headerText="FTB" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='closernoemployee' headerText="# Emp" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='closer' headerText="Closer" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='exitclosernoemp' headerText="# Emp" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='exitcloser' headerText="Exit Closer" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='vlonoemp' headerText="# Emp" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='vlo' headerText="VLO" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='comentarios' headerText="Comments" minWidth='10' textAlign="Left" />
                    </ColumnsDirective>
                    <AggregatesDirective>
                        <AggregateDirective>
                            <AggregateColumnsDirective>
                                <AggregateColumnDirective field='tieneflujo' type='Custom' customAggregate={customAggregateFnSumTieneFlujo} />
                                <AggregateColumnDirective field='cont' type='Sum' customAggregate={footerSum} />
                                <AggregateColumnDirective field='processable' type='Sum' format="C2" customAggregate={footerSum} />
                                <AggregateColumnDirective field='oopVolume' type='Sum' format="C2" customAggregate={footerSum} />
                                <AggregateColumnDirective field='downgrade' type='Sum' format="C2" customAggregate={footerSum} />
                                <AggregateColumnDirective field='cancelledVolume' type='Sum' format="C2" customAggregate={footerSum} />
                                <AggregateColumnDirective field='totalVolume' type='Sum' format="C2" customAggregate={footerSum} />
                                <AggregateColumnDirective field='volumensiniva' type='Sum' format="C2" customAggregate={footerSum} />
                                <AggregateColumnDirective field='pendingVolume' type='Sum' format="C2" customAggregate={footerSum} />
                                <AggregateColumnDirective field='ccobrado' type='Sum' format="C2" customAggregate={footerSum} />
                                <AggregateColumnDirective field='engancheTDC' type='Sum' format="C2" customAggregate={footerSum} />
                                <AggregateColumnDirective field='engancheVCM' type='Sum' format="C2" customAggregate={footerSum} />
                                <AggregateColumnDirective field='dpCollected' type='Sum' format="C2" customAggregate={footerSum} />
                                <AggregateColumnDirective field='enganchePendiente' type='Sum' format="C2" customAggregate={footerSum} />
                            </AggregateColumnsDirective>
                        </AggregateDirective>
                    </AggregatesDirective>
                </GridComponent>
            </div>
        </div>
    );
}

export default SalesReport;
